import { Counter } from "../../Counter/index.js";
import { Tooltip } from "../../Tooltip/index.js";
import { Link } from "../../Link/index.js";
import { IconWrapper, ItemGroup } from "./ItemGroup.js";
import React from "react";
import { IconPuzzle } from "@synthesis/shared-icons";
import { cn } from "@synthesis/shared-utils";
import { jsx, jsxs } from "react/jsx-runtime";
import { useRouterState } from "@tanstack/react-router";
//#region src/Navbar/local-components/SectionGroup.tsx
const SectionGroup = ({ isCollapsedNavBar, group, isLoadingDescription, handleGetIsUniqLink }) => {
	const pathname = useRouterState({ select: (state) => state.location.pathname });
	const isDescription = Boolean(group.descriptionItems);
	const isUniqLink = handleGetIsUniqLink(group);
	const isActiveItems = group.itemsStartsWith ? group.exact ? pathname === group.itemsStartsWith : pathname.includes(group.itemsStartsWith) : false;
	const iconGroup = React.useMemo(() => {
		if (group.openIcon && isActiveItems) return group.openIcon;
		if (group.icon) return group.icon;
		return /* @__PURE__ */ jsx(IconPuzzle, { className: "size-4" });
	}, [group, isActiveItems]);
	const groupItems = group.items?.map((item) => /* @__PURE__ */ jsx(ItemGroup, {
		item,
		isCollapsedNavBar,
		handleGetIsUniqLink
	}, item.id));
	const description = group.description ? !isLoadingDescription ? /* @__PURE__ */ jsx("p", {
		className: cn("text-type-light line-clamp-2 max-w-full break-all pr-2 text-xs font-medium leading-4 duration-75 ease-in-out", isCollapsedNavBar ? "max-h-0 w-0" : "max-h-12 w-full"),
		children: group.descriptionItems
	}) : /* @__PURE__ */ jsx("div", { className: cn("bg-neutrals-80 w-[90%] animate-pulse rounded duration-200 ease-in-out", isCollapsedNavBar ? "h-0 p-0" : "h-4 py-1") }) : null;
	return /* @__PURE__ */ jsxs("section", {
		className: cn("hover:bg-neutrals-90 mb-1 rounded-[10px] bg-transparent transition-all duration-300 ease-in-out", isActiveItems && "bg-neutrals-90", isUniqLink && "bg-neutrals-90", isCollapsedNavBar ? "mx-5" : "mx-2"),
		children: [/* @__PURE__ */ jsx(Link, {
			"data-cy": "navbar-link-navigation",
			to: group.link ?? "/",
			className: cn("group flex min-h-8 w-full items-center justify-center rounded-xl ease-in-out", "focus-within:outline-system-info-70 focus-within:outline focus-within:outline-2 focus-within:outline-offset-1"),
			children: /* @__PURE__ */ jsx(Tooltip, {
				"data-cy": "navbar-tooltip-navigation",
				disabled: !isCollapsedNavBar,
				description: group.label,
				arrowSide: "right",
				arrowAlign: "center",
				delayDuration: 0,
				sideOffset: 0,
				children: /* @__PURE__ */ jsxs("div", {
					className: cn("text-labels-secondary flex items-center px-5 duration-75", isCollapsedNavBar ? "h-8 w-full gap-0" : "h-full w-full gap-3"),
					children: [/* @__PURE__ */ jsx(IconWrapper, {
						isUniqLink,
						children: iconGroup
					}), /* @__PURE__ */ jsxs("div", {
						className: cn("flex w-full items-center justify-between overflow-hidden duration-200 ease-in-out", isCollapsedNavBar ? "w-0" : "w-full"),
						children: [/* @__PURE__ */ jsx("span", {
							"data-cy": "navbar-label-navigation",
							className: cn("group-hover:text-brand-40 mt-0.5 flex w-full truncate text-left text-xs font-medium leading-4 duration-200 ease-in-out", isUniqLink && "text-brand-40", isCollapsedNavBar ? "opacity-0" : "opacity-100"),
							children: group.label
						}), group.count ? /* @__PURE__ */ jsx(Counter, { count: group.count }) : null]
					})]
				})
			})
		}), group.items && isActiveItems ? /* @__PURE__ */ jsx("section", {
			className: cn("flex w-full", !isUniqLink && "grid-rows-1"),
			children: /* @__PURE__ */ jsxs("div", {
				className: cn("w-full duration-100 ease-in-out", isCollapsedNavBar ? "pl-0" : "mt-3 pl-[23px]", !isDescription && "mt-0"),
				children: [description, /* @__PURE__ */ jsx("div", {
					className: cn("flex flex-col items-start px-2.5 pb-1 duration-200 ease-in-out", isCollapsedNavBar ? "mt-1 gap-0 border-0" : "border-neutrals-80 mb-1.5 mt-4 gap-0 border-l-2", !isDescription && "mt-1"),
					children: groupItems
				})]
			})
		}) : null]
	});
};
//#endregion
export { SectionGroup };

//# sourceMappingURL=SectionGroup.js.map